"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
var _banner = require("@/api/banner/banner");
var _index = require("@/api/college/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: {
    type: Number
  },
  data: function data() {
    return {
      info: {},
      swiperList: []
    };
  },
  created: function created() {
    this.getShoolInfo();
    console.log(localStorage.getItem('wShoolInfo'), 'wShoolInfo');
    // console.log(this.$store.getters.wShoolInfo,'6666');
  },
  methods: {
    // 获取学校名称 id 背景图
    getShoolInfo: function getShoolInfo() {
      var _this = this;
      (0, _index.getShoolByCode)({
        param: this.$store.getters.wCode
      }).then(function (res) {
        if (res.code === 2000) {
          if (res.data.backgroupImge) {
            _this.bgImg = res.data.backgroupImge;
          }
          _this.$store.commit('settings/getwShoolInfo', res.data);
          _this.getSwiper();
        }
      });
    },
    //轮播图跳转
    toLink: function toLink(url) {
      if (url) {
        window.open(url);
      }
    },
    // 获取轮播图数据
    getSwiper: function getSwiper() {
      var _this2 = this;
      // this.info = JSON.parse(localStorage.getItem("wShoolInfo"));
      (0, _banner.selectPageList)({
        pageNum: 1,
        pageSize: 99999,
        schoolId: this.$store.getters.wShoolInfo.id
      }).then(function (res) {
        console.log(res);
        var data = res.data;
        _this2.swiperList = data.list;
      });
    }
  }
};